<template>
    <div class="manager-apply-page">
        <h3 class="page-title">投注站众筹招股</h3>
        <el-form ref="form" :model="form" :rules="rules" label-width="140px">
            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" placeholder="投注站(或站长用户名)+彩种+期号"></el-input>
            </el-form-item>
            <el-form-item label="关联实战团队方案" prop="scheme">
                <el-select v-model="form.scheme" placeholder="请选择关联实战团队方案" filterable clearable style="width:100%" @change="handleSchemeChange">
                    <el-option v-for="item in schemeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="众筹彩种">
                <el-input :value="form.lotteryTypeName" placeholder="随关联方案自动带出" disabled></el-input>
            </el-form-item>
            <el-form-item label="出票站号" prop="bettingShopNumber">
                <el-input v-model="form.bettingShopNumber" placeholder="自动获取出票站号" disabled></el-input>
            </el-form-item>
            <el-form-item label="出票站点" prop="bettingShopAddress">
                <el-input v-model="form.bettingShopAddress" placeholder="自动获取出票站点" disabled></el-input>
            </el-form-item>
            <el-form-item label="期号" prop="issueNumber">
                <el-input v-model="form.issueNumber" placeholder="自动获取下一期期号" disabled></el-input>
            </el-form-item>
            <el-form-item label="众筹定额股数">
                <el-input :value="form.crowdfundingNumber" placeholder="众筹定额股数(固定100)" disabled></el-input>
            </el-form-item>
            <el-form-item label="每人限购股数" prop="perPersonLimit">
                <el-input v-model="form.perPersonLimit" placeholder="每人限购股数(最大10)" @input="onAmountInput('perPersonLimit', $event)"></el-input>
            </el-form-item>
            <el-form-item label="每股价格" prop="crowdfundingPrice">
                <el-input v-model="form.crowdfundingPrice" placeholder="每股价格" @input="onAmountInput('crowdfundingPrice', $event)"></el-input>
            </el-form-item>
            <el-form-item label="众筹说明" prop="explanation">
                <el-input v-model="form.explanation" type="textarea" placeholder="多行输入"></el-input>
            </el-form-item>
            <el-form-item label="实战详情" prop="details">
                <el-input v-model="form.details" type="textarea" placeholder="开奖当天停售前自动显示,停售后自动显示"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :loading="publishing" @click="submitPublish">确定发布</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { publishOffering, getMyPurchaseList, getNextPeriod, getMyBettingShop } from '@/api/personalCenter'

export default {
    data() {
        return {
            publishing: false,
            // 关联实战团队方案下拉选项（接口拉取后自动填充）
            schemeOptions: [],
            form: {
                title: '',
                scheme: null,
                lotteryType: '', // 随关联方案自动带出
                lotteryTypeName: '', // 彩种展示名（只读）
                bettingShopNumber: '',
                bettingShopAddress: '',
                issueNumber: '',
                crowdfundingNumber: '100', // 写死固定 100，不可改
                perPersonLimit: '',
                crowdfundingPrice: '',
                explanation: '',
                details: '',
                // 接口文档标记为必需但语义不明，发布时传固定兜底值
                pageNum: 1,
                pageSize: 10,
                type: '',
                // 关联海选方案ID，可选
                auditionEntryId: null
            },
            rules: {
                title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
                scheme: [{ required: true, message: '请选择关联实战团队方案', trigger: 'change' }],
                bettingShopNumber: [{ required: true, message: '请输入出票站号', trigger: 'blur' }],
                bettingShopAddress: [{ required: true, message: '请输入出票站点', trigger: 'blur' }],
                issueNumber: [{ required: true, message: '请输入期号', trigger: 'blur' }],
                perPersonLimit: [{ required: true, message: '请输入每人限购股数', trigger: 'blur' }],
                crowdfundingPrice: [{ required: true, message: '请输入每股价格', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        this.loadSchemeOptions()
        this.loadMyBettingShop()
    },
    methods: {
        // 关联实战团队方案下拉数据
        loadSchemeOptions() {
            getMyPurchaseList().then(res => {
                const list = (res && res.rows) || (res && res.data) || []
                this.schemeOptions = list.map(item => {
                    const lt = item.lotteryType != null ? item.lotteryType : (item.preType != null ? item.preType : '')
                    return {
                        value: item.id != null ? item.id : (item.marketId != null ? item.marketId : ''),
                        label: item.title || item.teamName || item.schemeName || ('方案' + (item.id != null ? item.id : '')),
                        lotteryType: lt,
                        lotteryTypeName: item.lotteryTypeName || item.preTypeName || item.typeName || this.lotteryLabel(lt)
                    }
                })
            }).catch(() => {
                this.schemeOptions = []
            })
        },
        // 我的出票站信息（站号/站点自动带出，不可修改）
        loadMyBettingShop() {
            getMyBettingShop().then(res => {
                // 返回 { code, msg, data: { bettingShopNumber, bettingShop, ... } }
                const data = res && res.data !== undefined ? res.data : res
                if (data) {
                    this.form.bettingShopNumber = data.bettingShopNumber != null ? String(data.bettingShopNumber) : ''
                    this.form.bettingShopAddress = data.bettingShop != null ? String(data.bettingShop) : ''
                }
            }).catch(() => {
                this.form.bettingShopNumber = ''
                this.form.bettingShopAddress = ''
            })
        },
        // 选中关联方案后，自动带出众筹彩种
        handleSchemeChange(val) {
            const opt = this.schemeOptions.find(o => o.value === val)
            if (opt) {
                this.form.lotteryType = opt.lotteryType != null ? opt.lotteryType : ''
                this.form.lotteryTypeName = opt.lotteryTypeName || ''
            } else {
                this.form.lotteryType = ''
                this.form.lotteryTypeName = ''
            }
            // 彩种确定后，自动拉取下一期期号并填充（不可修改）
            this.fetchNextPeriod(this.form.lotteryType)
        },
        // 根据众筹彩种获取下一期期号，自动填充到期号输入框
        fetchNextPeriod(type) {
            if (type === '' || type == null) {
                this.form.issueNumber = ''
                return
            }
            getNextPeriod(type).then(res => {
                // 返回 { code, msg, data: { preType, lotteryName, nextPeriod } }，期号取 data.nextPeriod
                const base = res && res.data !== undefined ? res.data : res
                const period = base && base.nextPeriod
                if (period != null && period !== '') {
                    this.form.issueNumber = String(period)
                } else {
                    this.form.issueNumber = ''
                }
            }).catch(() => {
                this.form.issueNumber = ''
            })
        },
        // 彩种值 → 展示名兜底映射（后台未返回名称时使用）
        lotteryLabel(type) {
            const map = {
                '0': '双色球', '1': '大乐透',
                '2': '福彩3D', '3': '排列三',
                '4': '福彩3D'
            }
            return type != null && map[type] ? map[type] : ''
        },
        // 限制数量/金额类字段输入
        onAmountInput(field, val) {
            if (field === 'perPersonLimit') {
                // 仅允许整数，最大 10
                let v = String(val).replace(/[^0-9]/g, '')
                if (v !== '') {
                    let n = parseInt(v, 10)
                    if (n > 10) n = 10
                    v = String(n)
                }
                this.$set(this.form, field, v)
                return
            }
            if (field === 'crowdfundingPrice') {
                // 仅允许整数，最多 9 位，最大 999999999（9 个 9）
                let v = String(val).replace(/[^0-9]/g, '')
                if (v !== '') {
                    let n = parseInt(v, 10)
                    if (n > 999999999) n = 999999999
                    v = String(n)
                }
                this.$set(this.form, field, v)
                return
            }
            this.$set(this.form, field, val)
        },
        // 构建发布请求体
        buildPayload() {
            const f = this.form
            return {
                title: f.title,
                scheme: f.scheme ? Number(f.scheme) : null,
                lotteryType: f.lotteryType,
                bettingShopNumber: f.bettingShopNumber,
                bettingShopAddress: f.bettingShopAddress,
                issueNumber: f.issueNumber,
                crowdfundingNumber: 100, // 写死固定 100
                personLimit: f.perPersonLimit === '' ? 0 : Number(f.perPersonLimit),
                crowdfundingPrice: f.crowdfundingPrice === '' ? 0 : Number(f.crowdfundingPrice),
                explanation: f.explanation,
                details: f.details,
                pageNum: f.pageNum,
                pageSize: f.pageSize,
                type: f.type,
                auditionEntryId: f.auditionEntryId
            }
        },
        submitPublish() {
            this.$refs.form.validate(valid => {
                if (!valid) return
                this.publishing = true
                publishOffering(this.buildPayload()).then(res => {
                    if (res && res.code == 200) {
                        this.$message.success('发布成功')
                        this.$router.push('/personalCenter/tzz_bf/myOffering')
                    } else {
                        this.$message.error((res && res.msg) || '发布失败')
                    }
                }).catch(err => {
                    this.$message.error((err && err.message) || '发布失败')
                }).finally(() => {
                    this.publishing = false
                })
            })
        },
        resetForm() {
            this.$refs.form && this.$refs.form.resetFields()
            this.form.lotteryType = ''
            this.form.lotteryTypeName = ''
            // 重新拉取出票站信息，回填只读字段
            this.loadMyBettingShop()
        }
    }
}
</script>

<style lang="scss" scoped>
.manager-apply-page {
    padding: 20px;
}
.page-title {
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: 600;
}
</style>